import { render, staticRenderFns } from "./TopCustomerWidget.vue?vue&type=template&id=5ce74f10&scoped=true&"
import script from "./TopCustomerWidget.vue?vue&type=script&lang=js&"
export * from "./TopCustomerWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopCustomerWidget.vue?vue&type=style&index=0&id=5ce74f10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce74f10",
  null
  
)

export default component.exports